module.exports = __webpack_public_path__ + "static/media/q4-19-bg.87f81d66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/RoadMapResources/q4-19-bg.svg
// module id = 201
// module chunks = 0